import VideocamOutlinedIcon from '@material-ui/icons/VideocamOutlined';
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined';

/**
 * Vocabulário de local do compromisso — rótulo e ícone — usado na configuração
 * do calendário, na lista e nos modais. O link público tem texto próprio,
 * voltado ao convidado ("Os detalhes da chamada chegam por e-mail"), e por isso
 * não vem daqui.
 */

/** O componente, não o elemento: quem usa decide tamanho e cor. */
export const APPOINTMENT_LOCATION_ICONS = {
  google_meet: VideocamOutlinedIcon,
  in_person: PlaceOutlinedIcon,
  phone: PhoneOutlinedIcon,
  custom: TuneOutlinedIcon,
};

export const appointmentLocationIcon = (locationType) =>
  APPOINTMENT_LOCATION_ICONS[locationType] || APPOINTMENT_LOCATION_ICONS.custom;

export const APPOINTMENT_LOCATION_OPTIONS = [
  { value: 'google_meet', label: 'Google Meet' },
  { value: 'in_person', label: 'Presencial' },
  { value: 'phone', label: 'Telefone' },
  { value: 'custom', label: 'Personalizado' },
];

export const APPOINTMENT_LOCATION_LABELS = APPOINTMENT_LOCATION_OPTIONS.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {}
);

export const appointmentLocationLabel = (locationType) =>
  APPOINTMENT_LOCATION_LABELS[locationType] || APPOINTMENT_LOCATION_LABELS.custom;

/**
 * Texto completo do local: rótulo mais os detalhes que a empresa escreveu
 * (endereço, telefone, instruções). Sem detalhes, devolve só o rótulo.
 */
export const appointmentLocationText = (locationType, locationDetails) => {
  const label = appointmentLocationLabel(locationType);
  const details = locationDetails?.trim();
  return details ? `${label} — ${details}` : label;
};

/**
 * Local efetivo do compromisso: o que foi escolhido nele, ou o padrão do
 * calendário quando não há override — mesmo critério do backend
 * (`appointmentLocation.ts`). `appointment`/`calendar` aceitam `null`/`undefined`
 * pra chamar direto com o que a tela já tem à mão.
 */
export const resolveAppointmentLocation = (appointment, calendar) => ({
  type: appointment?.locationType ?? calendar?.locationType,
  details: appointment?.locationDetails ?? calendar?.locationDetails,
});
